/** Navigation route contexts — no imports, safe for redux slices. */
export enum AppContext {
    None = '',
    Office = 'office',
    Actions = 'actions',
    Draw = 'draw',
    Assets = 'assets',
    Quiz = 'quiz',
    Game = 'game',
    Challenges = 'challenges',
    Faq = 'faq',
}
